export const dataWithoutAdminAndModerator = (data) => {
  if (data.length) {
    return data.filter(
      (itemData) => itemData.customId !== 1 && itemData.customId !== 2
    );
  }
  return data;
};
